import { Navigate, useParams, useSearchParams } from 'react-router-dom';

import {
  Badge,
  Content,
  Layout,
} from 'apps/dashboard/shared/scripts/components';
import {
  PlanType,
  Status,
} from 'apps/shared/scripts/__generated__/graphql.generated';
import { PRO_MODE_ENABLED } from 'apps/shared/scripts/feature-gating/constants';
import useFeatureGate from 'apps/shared/scripts/feature-gating/hooks';
import { useCardById } from 'apps/shared/scripts/graphql';
import { useOnError } from 'apps/shared/scripts/hooks';

import {
  DeleteCard,
  LoadingCard,
  SendCard,
  UpgradeCard,
  ViewCard,
} from '../../components';
import CardArchivedContainer from '../CardArchivedContainer/CardArchivedContainer';
import CardFormContainer from '../CardFormContainer';

import messages from './messages.json';

const CardDetailsContainer = () => {
  const [searchParams] = useSearchParams();
  const redirect = searchParams.get('rd');
  const { cardId } = useParams();
  const { onError } = useOnError();
  const { card, isLoading } = useCardById({
    variables: { id: cardId! },
    onError,
  });
  const isPro = card && card.plan === PlanType.Pro;
  const isDelivered =
    card && (card.status === Status.Published || card.status === Status.Sent);

  const isProModeEnabled = useFeatureGate(PRO_MODE_ENABLED);

  return (
    <Layout>
      <Content
        backTo={redirect ? '/dashboard/cards' : undefined}
        rightHeader={
          isLoading ? null : !card ? null : isDelivered ? (
            <ViewCard cardId={cardId!} />
          ) : (
            <>
              <ViewCard cardId={cardId!} />
              <SendCard cardId={cardId!} />
              {isProModeEnabled && !isLoading && !isPro && (
                <UpgradeCard cardId={cardId!} />
              )}
              <DeleteCard cardId={cardId!} />
            </>
          )
        }
        title={messages.cardDetailsTitle}
        badge={isPro && <Badge label={'Pro'} />}
      >
        {isLoading ? (
          <LoadingCard />
        ) : !card ? (
          <>
            <Navigate to={'/not-found'} replace />
          </>
        ) : isDelivered ? (
          <CardArchivedContainer card={card} />
        ) : (
          <CardFormContainer card={card} />
        )}
      </Content>
    </Layout>
  );
};

CardDetailsContainer.displayName = 'CardDetailsContainer';

export default CardDetailsContainer;
